import InfoRounded from "@mui/icons-material/InfoRounded";
import CustomModal from "./CustomModal";
import OnboardingVideo from "./OnboardingVideo";

export default function OnboardingVideoModal({
  opened,
  onClose,
}: {
  opened: boolean;
  onClose: () => void;
}) {
  return (
    <CustomModal
      title="Tiber Tutor Demo"
      TitleIcon={InfoRounded}
      size="xl"
      opened={opened}
      onClose={onClose}
    >
      <OnboardingVideo />
    </CustomModal>
  );
}
